var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1017 15.9699C23.6711 14.6043 23.9856 13.1058 23.9856 11.5338C23.9856 9.96184 23.6711 8.46331 23.1016 7.09772H1.80193C1.23245 8.46331 0.917969 9.96184 0.917969 11.5338C0.917969 13.1058 1.23245 14.6043 1.80192 15.9699H23.1017Z",
    fill: "#FFDB2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1049 15.9699H1.80518C3.54334 20.138 7.65706 23.0676 12.455 23.0676C17.253 23.0676 21.3667 20.138 23.1049 15.9699ZM23.1049 7.09772H1.80519C3.54335 2.92967 7.65707 0 12.455 0C17.253 0 21.3667 2.92967 23.1049 7.09772Z",
    fill: "#F93939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.c4fddcc1c1cf57b7eb62c96577e6f2d9.svg";
export { ForwardRef as ReactComponent };